// turbowalk stand-in: recursive directory walk over the fs shim (and thus
// the FSA mounts). Matches the call shape used by the renderer's
// discovery walk: turbowalk(basePath, progressCB, options) where
// progressCB receives batches of {filePath, isDirectory, size, mtime,
// isTerminator} entries.
const fsPromises = require("./fs-promises.cjs");

async function turbowalk(basePath, progressCB, options = {}) {
    const recurse = options.recurse !== false;
    const emitTerminators = options.terminators === true;

    async function walkDir(dirPath) {
        let entries;
        try {
            entries = await fsPromises.readdir(dirPath, {
                withFileTypes: true,
            });
        } catch (err) {
            // unreadable directories (EPERM/ENOENT) are skipped, like turbowalk
            return;
        }

        const batch = [];
        const subDirs = [];
        for (const entry of entries) {
            const filePath = `${dirPath}/${entry.name}`;
            const isDirectory = entry.isDirectory();
            let size = 0;
            let mtime = 0;
            if (!isDirectory && options.details !== false) {
                try {
                    const stats = await fsPromises.stat(filePath);
                    size = stats.size;
                    mtime = Math.floor(stats.mtimeMs / 1000);
                } catch (err) {
                    // stat failures don't abort the walk
                }
            }
            batch.push({
                filePath,
                isDirectory,
                size,
                mtime,
                isTerminator: false,
            });
            if (isDirectory && recurse) {
                subDirs.push(filePath);
            }
        }

        if (batch.length > 0) {
            progressCB(batch);
        }

        for (const subDir of subDirs) {
            await walkDir(subDir);
        }

        if (emitTerminators) {
            progressCB([
                {
                    filePath: dirPath,
                    isDirectory: true,
                    size: 0,
                    mtime: 0,
                    isTerminator: true,
                },
            ]);
        }
    }

    await walkDir(String(basePath).replace(/\\/g, "/").replace(/\/+$/, ""));
}

module.exports = turbowalk;
module.exports.default = turbowalk;
